<template>
  <a-modal
    centered
    title="设置打印菜品"
    v-model="visible"
    width="1000px"
    @cancel="onCancel"
    @ok="onSubmit"
    :maskClosable="false"
    :destroyOnClose="true"
    :confirmLoading="confirmLoading"
  >
    <a-layout id="components-layout-demo-side">
      <a-layout-sider>
        <h3 class="catebox-title"><a-icon type="bars" /> 菜品类别</h3>
        <a-menu
          style="width: 195px"
          mode="vertical"
          :selectedKeys="selectedKeys"
          @click="onSelect"
          class="food-catebox"
        >
          <a-menu-item
            v-for="item in categoryList"
            :key="item.Id"
            :value="item.Id"
          >
            {{ item.Name }}
          </a-menu-item>
        </a-menu>
      </a-layout-sider>
      <a-layout>
        <a-layout-content :style="{ margin: '0 5px', overflow: 'initial' }">
          <div
            :style="{
              borderBottom: '1px solid #E9E9E9',
              paddingBottom: '5px',
              marginBottom: '5px'
            }"
          >
            <a-checkbox
              :checked="checkAll"
              :indeterminate="indeterminate"
              @change="onCheckAllChange"
            >
              全选
            </a-checkbox>
          </div>
          <div class="foods-check-cnt">
            <a-checkbox
              v-for="item in currentFoods"
              :key="item.FoodId"
              :checked="item.IsChecked"
              @change="onChange($event, item)"
              >{{ item.FoodName }}</a-checkbox
            >
          </div>
        </a-layout-content>
      </a-layout>
    </a-layout>
  </a-modal>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      visible: false,
      id: "",
      confirmLoading: false,
      currentFoods: [],
      checkedList: [],
      categoryList: [],
      foodsOptions: [],
      selectedKeys: [],
      allData: []
    };
  },
  computed: {
    checkAll() {
      return this.currentFoods.length &&
        this.currentFoods.filter(el => el.IsChecked).length ==
          this.currentFoods.length
        ? true
        : false;
    },
    indeterminate() {
      return this.currentFoods.filter(el => el.IsChecked).length > 0 &&
        !this.checkAll
        ? true
        : false;
    }
  },
  created() {
    this.getCategoryList();
  },
  methods: {
    onSelect({ key }) {
      this.selectedKeys = [key];
      this.currentFoods = this.allData.find(el => el.Id == key).Foods;
      this.checkedList = [];
    },
    getCategoryList() {
      this.$post("MaintenancePage_List", {
        Type: "FoodCategory",
        PageIndex: 0,
        PageSize: 1000
      }).then(res => {
        this.categoryList = [
          {
            Id: "0",
            Name: "全部"
          },
          ...res.Data.Datas
        ];
        this.selectedKeys = [this.categoryList[0].Id];
      });
    },
    getFoods() {
      this.$post("GetPrinterFoods", { Id: this.id }).then(res => {
        this.foodsOptions = res.Data;
        this.allData = this.categoryList.map(ele => {
          ele.Foods = this.foodsOptions.filter(
            item => item.FoodCategoryId == ele.Id
          );
          return ele;
        });
        this.allData[0].Foods = this.foodsOptions;
        this.currentFoods = this.allData[0].Foods;
      });
    },
    onChange(e, item) {
      item.IsChecked = e.target.checked;
    },
    onCheckAllChange(e) {
      this.currentFoods.forEach(el => {
        el.IsChecked = e.target.checked;
      });
    },
    show(id) {
      this.visible = true;
      this.id = id;
      this.selectedKeys = [this.categoryList[0].Id];
      this.getFoods();
    },
    onSubmit() {
      // let data = [];
      // this.allData.forEach(el => {
      //   data = data.concat(el.Foods);
      // });
      this.confirmLoading = true;
      this.$post("SetPrinterFoods", this.allData[0].Foods)
        .then(() => {
          this.$emit("update");
          this.visible = false;
          this.confirmLoading = false;
        })
        .catch(() => {
          this.confirmLoading = false;
        });
    },
    onCancel() {
      this.visible = false;
    }
  }
};
</script>

<style lang="less" scoped>
.catebox-title {
  background: #f0f2f5;
  margin-right: 5px;
  padding: 3px 5px;
}
.food-catebox {
  overflow: hidden;
  overflow-y: auto;
  height: calc(100vh - 300px);
  border-right: 0;
  border: 1px solid #f0f2f5;
  border-top: 0;
  /deep/.ant-menu-item {
    height: 30px;
    line-height: 30px;
    margin-bottom: 5px;
    padding-left: 22px;
  }
}
.ant-layout-sider {
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
  position: relative;
  background: white;
  min-width: 0;
}
.foods-check-cnt {
  overflow: hidden;
  overflow-y: auto;
  height: calc(100vh - 324px);
  /deep/.ant-checkbox-wrapper {
    // padding: 5px;
    // background: #fff;
    // border-radius: 3px;
    // margin: 5px 8px 0 0;
    padding: 5px;
    background: #fff;
    border-radius: 3px;
    margin: 3px 8px 0 0;
    display: inline-block;
    width: 132px;
    height: 31px;
    overflow: hidden;
  }
}
</style>
